import { render, staticRenderFns } from "./PAGoalSettingTabs.vue?vue&type=template&id=65ccf11c&scoped=true&"
import script from "./PAGoalSettingTabs.vue?vue&type=script&lang=js&"
export * from "./PAGoalSettingTabs.vue?vue&type=script&lang=js&"
import style0 from "./PAGoalSettingTabs.vue?vue&type=style&index=0&id=65ccf11c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ccf11c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
